import WellnessCheckService from 'src/modules/wellnessCheck/wellnessCheckService';
import Errors from 'src/modules/shared/error/errors';
import Message from 'src/view/shared/message';
import { getHistory } from 'src/modules/store';
import { i18n } from 'src/i18n';

const prefix = 'WELLNESS_CHECK_FORM';

const wellnessCheckFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: wellnessCheckFormActions.INIT_STARTED,
      });

      let record = {};

      const isEdit = Boolean(id);

      if (isEdit) {
        record = await WellnessCheckService.find(id);
      }

      dispatch({
        type: wellnessCheckFormActions.INIT_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: wellnessCheckFormActions.INIT_ERROR,
      });

      getHistory().push('/wellness-check');
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: wellnessCheckFormActions.CREATE_STARTED,
      });

      await WellnessCheckService.create(values);

      dispatch({
        type: wellnessCheckFormActions.CREATE_SUCCESS,
      });

      Message.success(
        i18n('entities.wellnessCheck.create.success'),
      );

      getHistory().push('/wellness-check');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: wellnessCheckFormActions.CREATE_ERROR,
      });
    }
  },

  doUpdate: (id, values) => async (dispatch, getState) => {
    try {
      dispatch({
        type: wellnessCheckFormActions.UPDATE_STARTED,
      });

      await WellnessCheckService.update(id, values);

      dispatch({
        type: wellnessCheckFormActions.UPDATE_SUCCESS,
      });

      Message.success(
        i18n('entities.wellnessCheck.update.success'),
      );

      getHistory().push('/wellness-check');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: wellnessCheckFormActions.UPDATE_ERROR,
      });
    }
  },
};

export default wellnessCheckFormActions;
